import { Injectable } from "@angular/core";
// import { AuthGuardService } from "./auth-guard.service";

@Injectable({
    providedIn: "root",
})
export class ConfigService {
    recaptchaSiteKeyV3: string = '6LfRh1IeAAAAAHtWRke9B5YG-QTnu3HpBhzAckg0';

    constructor(
        // private guard: AuthGuardService,
    ) { }

    async loadConfig() {
        // const siteKeyV3 = await this.guard.getrecapchekey().then(result => console.log(result));
        // console.log(siteKeyV3 + ' kllkjlkj');
        // this.recaptchaSiteKeyV3 = siteKeyV3;
    }
}